import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TUntinTarihuGetListReq,
  TUntinTarihuGetListRes,
  TUntinTarihuPutReq,
} from "./TUntinTarihu"

/**
 * 運賃タリフに対するAPIリクエスト用サービス
 *
 * @export
 * @class UntinTarihuService
 * @extends {ConnectApi}
 */
export default class UntinTarihuService extends ConnectApi {
  /**
   * 運賃タリフ 一覧取得
   *
   * @param {TUntinTarihuGetListReq} params
   * @param {(param: TApiResponse<TUntinTarihuGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TUntinTarihuGetListRes>) => any} reject
   * @memberof UntinTarihuService
   */
  getList = async (params: TUntinTarihuGetListReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<TZyomuinListGetRes>> =
      // await this.getInner(`/master/hinmei`, params)
      //return res.data
      //   if (params.年月 === "2" && params.品コード === "1") {
      //     // eslint-disable-next-line no-throw-literal
      //     throw "ERROR"
      //   }

      return {
        data: 運賃タリフ一覧dummyList,
      }

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 運賃タリフ 更新
   *
   * @param {TUntinTarihuPutReq} data
   * @param {(param: TApiResponse<TUntinTarihuGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TUntinTarihuGetListRes[]>>) => any} reject
   * @memberof UntinTarihuService
   */
  put = async (data: TUntinTarihuPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/untintarihu/list`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}

//TODO:ダミーデータ
const 運賃タリフ一覧dummyList: TUntinTarihuGetListRes[] = [
  {
    運賃タリフid: 1,
    荷主コード: "0001",
    荷主名: "荷主AAA",
    運賃タリフ区分コード: "1",
    備考: "あ",
    更新日時: "2022-01-01T00:00:00",
    modifyToken: "2022-02-01T00:00:00",
  },
  {
    運賃タリフid: 2,
    荷主コード: "0002",
    荷主名: "荷主BBB",
    運賃タリフ区分コード: "2",
    備考: "い",
    更新日時: "2022-01-01T00:00:00",
    modifyToken: "2022-02-01T00:00:00",
  },
  {
    運賃タリフid: 3,
    荷主コード: "0003",
    荷主名: "荷主CCC",
    運賃タリフ区分コード: "3",
    備考: "う",
    更新日時: "2022-01-01T00:00:00",
    modifyToken: "2022-02-01T00:00:00",
  },
]
